module.exports = __webpack_public_path__ + "static/image/font/pc/kkubulim-1.ver2_0_2.png?4377b5fd";